import { useQuery } from 'hooks/useCustomQuery';
import { getCountriesList } from 'API/Country/getCountriesList';

export const useGetCountriesList = ({ currentCompany }) => {
    return useQuery({
        queryKey: ['countries'],
        queryFn: async () => {
            try {
                const res = await getCountriesList();
                return res.data;
            } catch (error) {
                console.error('Error fetching countries:', error);
                throw error;
            }
        },
        refetchOnWindowFocus: false,
        retry: 0,
        refetchOnMount: false,
        enabled: Boolean(currentCompany),
        staleTime: 600 * 60 * 1000,
    });
};
